const tableRows = document.querySelectorAll(".availability-table-row");
const viewMoreBtn = document.querySelector(".view-more");

const rowInitialLimit = 5;

limitTableRows(tableRows);

if (viewMoreBtn) {
    viewMoreBtn.addEventListener('click', displayMoreRows);
}


function limitTableRows(rowsArr) {
    let rowNum = 1
    rowsArr.forEach(row => {
        row.dataset.rowNum = rowNum.toString();
        rowNum++;
        if (Number(row.dataset.rowNum) > rowInitialLimit) {
            row.style.display = 'none';
        }
    })

}

function displayMoreRows() {
    tableRows.forEach(row => {
        row.style.display = 'revert';
    })
    viewMoreBtn.style.display = 'none';
}




